<script>
	import Keyboard from './Keyboard.svelte';
    export let gotoHome = () => {};
	export let game;
	export let cfg;
	let hidden_text;
	let show_text;
	let gameRunning = false;
	let countDown;
	let keyboardStatus = [];

	function startGame(){
		console.log('startGame');
		hidden_text = game['words'][Math.floor(Math.random() * game['words'].length)];
		console.log(hidden_text);
		show_text = Array(5).fill(' ');
		countDown = 7;
		gameRunning = true;
	}
	function cancelGame(){
		console.log('cancelGame');
		gameRunning = false;
	}
	function keyPressed(){
		let char = this.innerText
        //console.log(char);

		let matched = false;
        for( let i = 0; i < hidden_text.length; i++) {
			if (hidden_text[i] == char) {
				show_text[i] = char;
				matched = true;
			}
		}
		if (matched) {
			console.log('letter matched');
			keyboardStatus[char] = 'goodkey';
			// count how many letter are the same in the hidden text as in the typed in text
			let count = 0;
			for (let i = 0; i < hidden_text.length; i++) {
				if (hidden_text[i] == show_text[i]) {
					count++;
				}
			}
			if (count == hidden_text.length) {
				console.log("The whole world was matched")
				window.confirm('Congratulations! You won!');
				cancelGame();
			}
		} else {
			console.log('letter NOT matched');
			keyboardStatus[char] = 'badkey';
			countDown--;
			if (countDown <= 0) {
				console.log('end of game');
				window.confirm('Oups. You ran out of options.');
				cancelGame();
			}
		}
    }
</script>


<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>

<h1>{cfg["title"]}</h1>

{#if !gameRunning}
<button on:click={startGame}>Start</button>
<div>
    <hr>
    <button on:click={gotoHome}>Home</button>
</div>

{/if}

{#if gameRunning}
<Keyboard keyPressed={keyPressed} {keyboardStatus} keyboardType={cfg['keyboard']} />

<div>
    {#each show_text as char, ix}
        {#if hidden_text[ix] == ' '}
           &nbsp;
        {:else}
            {#if char == ' '}
                _
            {:else}
                {char}
            {/if}
        {/if}
    {/each}
</div>


Countdown: {countDown}

<button on:click={cancelGame}>Cancel</button>
{/if}

